type UpdateDOMFieldParams = {
  element?: HTMLElement | null;
  fieldName: string;
  value: string;
  type?: 'input' | 'select';
};

export function updateDOMField(params: UpdateDOMFieldParams): void {
  const { element = document, fieldName, value, type = 'input' } = params;

  const target = element?.querySelector(`${type}[name="${fieldName}"]`) as HTMLInputElement | HTMLSelectElement;

  if (target) {
    const event = new Event(type === 'input' ? 'input' : 'change', { bubbles: true });

    target.value = value;
    target.dispatchEvent(event);
  }
}
